import React from "react";
import { Card } from "@UI/Components/Card/Card";
import { ServiceOfferDescriptionProps } from "./types";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";
import { ServiceOfferItem } from "../../../Purchasing/Components/OrderDescription/OrderDescriptionItems/ServiceOfferItem";
import { List } from "@UI/Components/List/List";
import { TotalServiceOffer } from "./TotalServiceOffer";
import { useServiceOffer } from "@modules/ServiceAssignment/hooks/useServiceOffer";
import { AdvancePaymentItem } from "./AdvancePaymentItem";
import { EstimationState } from "@modules/ServiceRequest/types";
import { useServiceProvider } from "@modules/ServiceProviders/hooks/useServiceProvider";
import { VisitOfferDetail } from "@modules/ServiceRequest/Components/VisitOfferDetail";
import { ServiceFees } from "@modules/Purchasing/Components/OrderDescription/OrderDescriptionItems/ServiceFees";
import { useServiceFeesFeature } from "@modules/ServiceFees/hooks/useServiceFeesFeature";

// The showServiceFees and showAdvancePayment props are used for the serviceOffer Modal.
// In that step(When the SP has made an offer, we don't want to show the fees or advance payment yet)
export const ServiceOfferDescription = ({
  serviceOfferId,
  showServiceFees = true,
  compactServiceFees = false,
  showAdvancePayment = true,
  colorScheme,
  subscriptionDiscountBadge,
  ...props
}: ServiceOfferDescriptionProps) => {
  // const { currentUser, isLoading: isLoadingCurrentUser } = useCurrentUser();

  const { serviceFeesFeature, isLoading: isServiceFeesLoading } =
    useServiceFeesFeature();

  const serviceFeePercentage =
    serviceFeesFeature?.details?.chargedToClient?.clientServiceFee?.percentage;

  const { serviceOffer, isLoading } = useServiceOffer(serviceOfferId);

  const { serviceProvider } = useServiceProvider(
    serviceOffer?.serviceProviderId,
    {
      includes: ["user"],
    }
  );

  const serviceProviderName = serviceProvider?.user?.firstName;

  // if (isLoading || isServiceFeesLoading || isLoadingCurrentUser) {
  //   return <LoadingScreen />;
  // }

  if (isLoading || isServiceFeesLoading) {
    return <LoadingScreen />;
  }

  if (!serviceOffer) return;

  const {
    rateCents,
    rateCurrency,
    billingCount,
    billingUnit,
    expenses,
    prepaidCents,
    serviceFeesCents,
    expensesFeesCents,
  } = serviceOffer;

  const totalExpensesAmount =
    expenses?.reduce((sum, expense) => sum + (expense.amountCents || 0), 0) ||
    0;

  return (
    <Card
      background={colorScheme === "sand" ? "sand.100" : "transparent"}
      shadow="none"
      padding={0}
      {...props}
    >
      {serviceOffer?.rateType === "estimate" &&
        (serviceOffer?.state === "waiting" ||
          serviceOffer?.estimationState === EstimationState.NOT_SENT) && (
          <VisitOfferDetail name={serviceProviderName} />
        )}

      <List>
        {(serviceOffer?.rateType !== "estimate" ||
          (serviceOffer.state === "accepted" &&
            serviceOffer.estimationState !== EstimationState.NOT_SENT)) && (
          <ServiceOfferItem
            preview
            priceCents={rateCents}
            currency={rateCurrency}
            billingCount={billingCount}
            billingUnit={billingUnit}
            expenses={expenses}
            serviceProviderId={serviceOffer?.serviceProvider?.id}
          />
        )}

        {showServiceFees && (
          <ServiceFees
            preview
            itemFeesCents={serviceFeesCents}
            serviceFeeRate={serviceFeePercentage}
            billingUnit={billingUnit}
            billingCount={billingCount}
            currency={rateCurrency}
            totalExpensesFees={expensesFeesCents}
            compact={compactServiceFees}
          />
        )}

        {showAdvancePayment && (
          <AdvancePaymentItem prepaidCents={prepaidCents} />
        )}

        {/* {!currentUser.subscribed && (
          <ClientProtectionFeeDetails
            isSubscribed={currentUser?.subscribed}
            serviceFeePercentage={serviceFeePercentage}
            serviceOffer={serviceOffer}
          />
        )} */}

        {/* <TotalServiceOffer
          isSubscribed={currentUser?.subscribed}
          serviceOfferId={serviceOfferId}
          colorScheme={colorScheme}
          includeAdvancePayment={showAdvancePayment}
          preview
        /> */}

        {/* {currentUser.subscribed && (
          <ClientProtectionFeeDetails
            isSubscribed={currentUser?.subscribed}
            serviceFeePercentage={serviceFeePercentage}
            serviceOffer={serviceOffer}
          />
        )} */}

        {subscriptionDiscountBadge}

        <TotalServiceOffer
          rateCents={rateCents}
          rateCurrency={rateCurrency}
          billingUnit={billingUnit}
          prepaidCents={prepaidCents}
          serviceFeeCents={serviceFeesCents}
          totalExpenses={totalExpensesAmount}
          totalExpensesFees={expensesFeesCents}
          colorScheme={colorScheme}
          includeFees={showServiceFees}
          includeAdvancePayment={showAdvancePayment}
          isEstimate={
            serviceOffer?.rateType === "estimate" &&
            (serviceOffer?.state === "waiting" ||
              serviceOffer?.estimationState === EstimationState.NOT_SENT)
          }
          preview
        />
      </List>
    </Card>
  );
};
